import { ReactNode } from 'react'
import { H1 } from '@/common/ui/h1'
import { H2 } from '@/common/ui/h2'

interface ListItem {
    key: string | number
}

interface DetailListSectionProps<T extends ListItem> {
    title: string
    items: T[]
    renderItem: (item: T, index: number, itemsLength: number) => ReactNode
    showDivider?: boolean
}

export function DetailListSection<T extends ListItem>({
    title,
    items,
    renderItem,
    showDivider = true,
}: DetailListSectionProps<T>) {
    return (
        <section className="self-stretch flex flex-col justify-start items-start gap-4 md:gap-6">
            <H1 className="block md:hidden leading-10 mb-0 font-['Tangerine']">{title}</H1>
            <H2 className="hidden md:block text-content-primary text-2xl md:text-3xl !font-normal font-['Serious_Sans'] leading-8 mb-0">
                {title}
            </H2>

            <div className="self-stretch flex flex-col justify-start items-start gap-3 md:gap-4">
                {items.map((item, index) => (
                    <div key={item.key} className="self-stretch flex flex-col justify-start items-start gap-3 md:gap-4">
                        {renderItem(item, index, items.length)}
                        {showDivider && index < items.length - 1 && (
                            <div className="self-stretch h-0 border-t border-border-divider" />
                        )}
                    </div>
                ))}
            </div>
        </section>
    )
}
